import CaseSearchNoResult from '@/shared/publish/MyPublications/CaseSearchNoResult'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/publish/MyPublications/CaseSearchNoResult',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <CaseSearchNoResult />
}
